import React from 'react'
import { Title, TitleWrapper } from './style'

export const DetailsTitle = (props) => {
    return (
        <div>
            <TitleWrapper>
            <Title {...props}>
                {props.text}
            </Title>
            </TitleWrapper>

        </div>
    )
}
